"use strict";import{IconMagnify as n}from"../src/elements/IconMagnify.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-magnify",n);
//# sourceMappingURL=sp-icon-magnify.js.map
